import type { CampoRedactableDesdeTerreno } from "@/lib/ia";
import type { CampoDeTerreno } from "@/lib/terreno";

import { PanelDeTerrenoDeLaDescripcion } from "./PanelDeTerrenoDeLaDescripcion";
import { RedactarDesdeTerreno } from "./RedactarDesdeTerreno";
import {
  puedeRedactarDesdeTerreno,
  vistaDeTerreno,
  type EstadoDelTerreno,
} from "./terrenoDeAntecedentes";

/** Los botones de la cabecera de la caja: más bajos que `sm`, como en el diseño. */
const CLASE_DEL_BOTON =
  "h-7 rounded-[0.5625rem] px-2.5 text-[0.6875rem] has-[>svg]:px-2.5 [&_svg:not([class*='size-'])]:size-3";

interface TerrenoDeLaDescripcionProps {
  informeId: number;
  terreno: EstadoDelTerreno | undefined;
  /** El campo de terreno de ESTA descripción (el mismo que lee «Redactar desde terreno»). */
  campo: CampoDeTerreno | null;
  /** Qué descripción redacta el servidor. */
  campoRedactable: CampoRedactableDesdeTerreno;
  /** Lo que el texto tiene hoy: con algo escrito, redactar pregunta antes de reemplazar. */
  valorActual: string;
  /** Quién tiene asignada la visita. */
  asignado: string | null;
  onAbrirFoto: (uuid: string) => void;
  /** Recibe el texto redactado: quien llama lo pone en el formulario y desmarca la casilla. */
  onRedactado: (texto: string) => void;
}

/**
 * La caja plegable «Registro de terreno» que Maquinaria, Instalaciones y
 * Plantaciones dibujan BAJO el texto de su descripción: lo que el encargado
 * grabó para esa descripción y el botón «Redactar desde terreno».
 *
 * Es el panel de Suelos, Aguas y Construcciones en su variante `desplegable`:
 * mismo contenido, mismas reglas. «Redactar desde terreno» PROPONE y no guarda
 * —el texto entra al formulario como cambio sin guardar— y solo se ofrece
 * cuando el campo trae algo que leer, porque en los demás casos el servidor
 * respondería 422. Con el módulo de terreno apagado no se dibuja nada.
 */
export function TerrenoDeLaDescripcion({
  informeId,
  terreno,
  campo,
  campoRedactable,
  valorActual,
  asignado,
  onAbrirFoto,
  onRedactado,
}: TerrenoDeLaDescripcionProps) {
  if (!terreno || terreno.estado === "no_disponible") return null;

  const registro = terreno.estado === "ok" ? terreno.registro : undefined;

  return (
    <PanelDeTerrenoDeLaDescripcion
      variante="desplegable"
      informeId={informeId}
      terreno={terreno}
      vista={registro ? vistaDeTerreno(registro) : null}
      campo={campo}
      asignado={asignado}
      onAbrirFoto={onAbrirFoto}
      acciones={
        terreno.estado === "ok" && puedeRedactarDesdeTerreno(campo) ? (
          <RedactarDesdeTerreno
            informeId={informeId}
            campo={campoRedactable}
            valorActual={valorActual}
            claseDelBoton={CLASE_DEL_BOTON}
            onRedactado={onRedactado}
          />
        ) : null
      }
    />
  );
}
